// Lightbox state (global: also invoked from onclick="" attributes in server- and JS-rendered markup)
let currentProductImageIndex = 0;
let productImages = [];

function escapeHtml(str) {
  return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function openProductLightbox(index) {
  currentProductImageIndex = index;
  const lightbox = document.getElementById('productLightbox');
  const image = document.getElementById('lightboxProductImage');
  const counter = document.getElementById('currentImageNum');

  if (lightbox && image) {
    lightbox.classList.add('active');
    image.src = productImages[currentProductImageIndex];
    if (counter) counter.textContent = currentProductImageIndex + 1;
    document.body.style.overflow = 'hidden';
  }
}

function closeProductLightbox() {
  const lightbox = document.getElementById('productLightbox');
  if (lightbox) {
    lightbox.classList.remove('active');
    document.body.style.overflow = '';
  }
}

function changeProductImage(direction) {
  currentProductImageIndex += direction;

  if (currentProductImageIndex >= productImages.length) {
    currentProductImageIndex = 0;
  } else if (currentProductImageIndex < 0) {
    currentProductImageIndex = productImages.length - 1;
  }

  const image = document.getElementById('lightboxProductImage');
  const counter = document.getElementById('currentImageNum');

  if (image) image.src = productImages[currentProductImageIndex];
  if (counter) counter.textContent = currentProductImageIndex + 1;
}

document.addEventListener('keydown', function (e) {
  const lightbox = document.getElementById('productLightbox');
  if (lightbox && lightbox.classList.contains('active')) {
    if (e.key === 'Escape') {
      closeProductLightbox();
    } else if (e.key === 'ArrowLeft') {
      changeProductImage(-1);
    } else if (e.key === 'ArrowRight') {
      changeProductImage(1);
    }
  }
});

const lightboxEl = document.getElementById('productLightbox');
if (lightboxEl) {
  lightboxEl.addEventListener('click', function (e) {
    if (e.target === this) {
      closeProductLightbox();
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('.stm-product-gallery-desk');
  if (!root) return;

  const sectionId = root.dataset.sectionId;
  const gallerySectionId = root.dataset.gallerySectionId;

  const mainSlidesWrapper = document.querySelector('.custom-product-images-slider-new .swiper-wrapper');
  const thumbSlidesWrapper = document.querySelector('.mySwiperThumb .swiper-wrapper');
  const picksWrapper = document.querySelector('.custom-images-product-sec .custom-product-images');

  // Default (all product images) slide set, seeded server-side as a JSON data island.
  let defaultImages = [];
  const defaultImagesEl = document.getElementById('mj-gallery-default-images-' + sectionId);
  if (defaultImagesEl) {
    try {
      defaultImages = JSON.parse(defaultImagesEl.textContent || '[]');
    } catch (err) {
      console.error('mj-gallery-default-images: bad JSON', err);
    }
  }

  let swiper, swiperThumb;

  function renderSlides(wrapper, images, thumbMode) {
    wrapper.innerHTML = images.map(function (rawImg, index) {
      const img = { id: rawImg.id, src: escapeHtml(rawImg.src), thumb: escapeHtml(rawImg.thumb), alt: escapeHtml(rawImg.alt) };
      return (
        '<div class="swiper-slide" data-image-id="' + img.id + '">' +
          (thumbMode
            ? '<img src="' + img.thumb + '" alt="' + img.alt + '" loading="lazy" width="100%" height="auto" class="custom-swiper-cs-thumnil-gl" />'
            : '<a href="javascript:void(0);" onclick="openProductLightbox(' + index + ')">' +
                '<img class="main-product-image" src="' + img.src + '" width="100%" height="auto" loading="' + (index === 0 ? 'eager' : 'lazy') + '" alt="' + img.alt + '" />' +
              '</a>') +
        '</div>'
      );
    }).join('');
  }

  function renderPicks(wrapper, images) {
    wrapper.innerHTML = images.slice(1, 5).map(function (rawImg, index) {
      const img = { src: escapeHtml(rawImg.src), alt: escapeHtml(rawImg.alt) };
      return (
        '<a class="custom-product-picks" href="javascript:void(0);" onclick="openProductLightbox(' + (index + 1) + ')">' +
          '<img src="' + img.src + '" width="100%" height="auto" loading="lazy" alt="' + img.alt + '" />' +
        '</a>'
      );
    }).join('');
  }

  function initGallery(images) {
    if (!images.length) images = defaultImages;

    productImages = images.map(function (img) { return img.src; });
    const totalImagesEl = document.getElementById('totalImages');
    if (totalImagesEl) totalImagesEl.textContent = productImages.length;

    renderSlides(mainSlidesWrapper, images, false);
    renderSlides(thumbSlidesWrapper, images, true);
    if (picksWrapper) renderPicks(picksWrapper, images);

    if (swiper) swiper.destroy(true, true);
    if (swiperThumb) swiperThumb.destroy(true, true);

    swiperThumb = new Swiper('.mySwiperThumb', {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.thumb-swiper-button-next',
        prevEl: '.thumb-swiper-button-prev',
      },
      breakpoints: {
        320: { slidesPerView: 3, spaceBetween: 8 },
        480: { slidesPerView: 4, spaceBetween: 10 },
      },
    });

    swiper = new Swiper('.custom-product-images-slider-new', {
      slidesPerView: 1,
      spaceBetween: 10,
      speed: 1000,
      loop: images.length > 1,
      thumbs: {
        swiper: swiperThumb,
      },
    });

    currentProductImageIndex = 0;
  }

  function goToImageId(imageId) {
    if (!imageId || !swiper) return;

    const slides = document.querySelectorAll('.custom-product-images-slider-new .swiper-slide[data-image-id]');
    let slideIndex = -1;
    slides.forEach(function (slide, index) {
      if (slide.dataset.imageId == imageId) slideIndex = index;
    });

    if (slideIndex > -1) {
      currentProductImageIndex = slideIndex;
      if (swiper.params.loop) {
        swiper.slideToLoop(slideIndex);
      } else {
        swiper.slideTo(slideIndex);
      }
    }
  }

  // Cache of variantId -> gallery_images array, seeded with the current page's already-hydrated variant.
  const galleryCache = {};
  const currentGalleryEl = document.getElementById('mj-variant-gallery-current-' + gallerySectionId);
  if (currentGalleryEl) {
    try {
      galleryCache[currentGalleryEl.dataset.variantId] = JSON.parse(currentGalleryEl.textContent || '[]');
    } catch (err) {
      console.error('mj-variant-gallery-current: bad JSON', err);
    }
  }

  // Initial render: use the loaded variant's dedicated photo set if it has one, default set otherwise.
  const initialVariantId = currentGalleryEl && currentGalleryEl.dataset.variantId;
  const initialImages = (initialVariantId && galleryCache[initialVariantId] && galleryCache[initialVariantId].length)
    ? galleryCache[initialVariantId]
    : defaultImages;
  initGallery(initialImages);

  function extractGalleryImages(doc) {
    const el = doc.getElementById('mj-variant-gallery-current-' + gallerySectionId);
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || '[]');
    } catch (err) {
      console.error('mj-variant-gallery-current: bad JSON (fetched)', err);
      return [];
    }
  }

  function applyVariantImages(variantId, variantImages) {
    const imageMapEl = document.getElementById('mj-variant-image-map-' + sectionId);
    let imageMap = {};
    try {
      imageMap = imageMapEl ? JSON.parse(imageMapEl.textContent || '{}') : {};
    } catch (err) {
      console.error('mj-variant-image-map: bad JSON', err);
    }

    if (variantImages && variantImages.length) {
      // Merchant set a dedicated photo set for this variant — swap the whole gallery.
      initGallery(variantImages);
    } else {
      // No dedicated set: reset to the default set and jump to this variant's single featured image.
      initGallery(defaultImages);
      goToImageId(imageMap[variantId]);
    }
  }

  // Shopify only reliably hydrates a variant's reference-type metafields when that variant is the
  // one resolved as "selected" for the request. So for any variant we haven't seen yet, fetch this
  // variant's own render of the tiny mj-gallery-data section (making it the selected one) instead of
  // trusting a batch loop. That section is a few hundred bytes, so this stays fast.
  function selectVariant(variantId) {
    if (galleryCache[variantId]) {
      applyVariantImages(variantId, galleryCache[variantId]);
      return;
    }

    fetch(window.location.pathname + '?variant=' + variantId + '&section_id=' + gallerySectionId)
      .then(function (res) { return res.text(); })
      .then(function (text) {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const images = extractGalleryImages(doc);
        galleryCache[variantId] = images;
        applyVariantImages(variantId, images);
      })
      .catch(function (err) {
        console.error('mj gallery: variant fetch failed', err);
        applyVariantImages(variantId, []);
      });
  }

  // Jump gallery to the variant's image whenever the selected variant changes (standard Shopify variant-selects flow)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      const variant = event.data.variant;
      if (!variant) return;
      selectVariant(variant.id);
    });
  }

  // Jump gallery to the variant's image for this page's custom swatch picker
  document.addEventListener('mj:variant-selected', function (e) {
    selectVariant(e.detail.variantId);
  });
});
